module.exports = __webpack_public_path__ + "img/83.1527f41a.jpg";